import React from 'react';
import agent from '../../agent';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
const Promise = global.Promise;

const mapStateToProps = state => ({
  templates: state.templates,
  sites: state.sites,
});

const mapDispatchToProps = dispatch => ({
});


class ViewSite extends React.Component {
  constructor() {
    super();

    this.state = { 
      columns: [],
      siteData: {
        id: '',
        template: '',
        bridePhoto: '',
        engagementMapLocation: '',
        weddingLocation: '',
        weddingDatetime: '',
        engagementDatetime: '',
        couplePhoto: '',
        groom: '',
        bride: '',
        groomPhoto: '',
        weddingMapLocation: '',
        engagementLocation: '',
      },
    };
  }

  // componentWillMount() {
    // console.error(this.props.match.params.siteId);
  // }

  static getDerivedStateFromProps(props, state) {
    if ((props.templates && props.templates.length > 0 ) || (props.sites && props.sites.length > 0)) {
      let newColumns = state.columns;
      let newSiteData = state.siteData;
      props.sites.forEach(site => {
        if(props.match.params.siteId === site.id) {
          newSiteData = Object.assign({}, site);
        }
      });
      props.templates.forEach(template => {
        if(newSiteData.template === template.name) {
          newColumns = [...template.columns];
        }
      });
      const newState = Object.assign({}, state, {siteData: newSiteData}, {columns: newColumns});
      return newState;
    }
    return null;
  }

  render() {
    return (
      <div className="container">
        <h2>View Site</h2>
        <br/>
        <div>
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Field</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {this.state.columns.map((column, i) => 
                <tr key={i} style={{marginBottom: '5px'}}>
                  <td>
                    {column.label}
                  </td>
                  <td>
                    {this.state.siteData[column.name] && this.state.siteData[column.name].indexOf('files') !== -1 ? 
                      this.state.siteData[column.name].indexOf('dearinvite') == -1 ? <img src={'https://dearinvite.com'+this.state.siteData[column.name]} 
                        style={{maxWidth:'100px', maxHeight: '100px', borderRadius: '100%'}}/> : <img src={this.state.siteData[column.name]} 
                        style={{maxWidth:'100px', maxHeight: '100px', borderRadius: '100%'}}/> : 
                        this.state.siteData[column.name]} 
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <Link to={'/sites/'+this.state.siteData.id+'/edit'} className="btn btn-primary">Edit</Link>&nbsp;
          <Link to={'/sites'} className="btn btn-primary">All Sites</Link>&nbsp;
          <a href={'https://dearinvite.com/sites/'+this.state.siteData.id} target="_blank">Preview</a>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewSite);
